enum ClaimTypeEnum {
  CASUALTY = 'casualty',
  COMPREHENSIVE = 'comprehensive',
  DEBT_COLLECTION = 'debtCollection',
  DELIVERY = 'delivery',
  REGRESS = 'regress'
}

export default ClaimTypeEnum;
